/**
 * Маркер-класс для клониривания
 */
export abstract class Cloneable {
    abstract clone(): any;
}
